import { render, staticRenderFns } from "./EditList.vue?vue&type=template&id=e9013082&scoped=true&"
import script from "./EditList.vue?vue&type=script&lang=js&"
export * from "./EditList.vue?vue&type=script&lang=js&"
import style0 from "./EditList.vue?vue&type=style&index=0&id=e9013082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9013082",
  null
  
)

export default component.exports